export default "__VITE_ASSET__ca5b43df__"